var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:(_vm.title),expression:"title",modifiers:{"right":true}}]},[_c('a',{class:_vm.linkClass,attrs:{"href":_vm.href}},[_c('i',{class:_vm.iconClass})])])
}
var staticRenderFns = []

export { render, staticRenderFns }